/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import moment from 'moment-timezone'
import React, { useEffect, useImperativeHandle, useState } from 'react'

import globalNotification from 'live/services/global-notification'
import i18n from 'live/services/i18n'

import {
    exportRiskAcceptanceAndRiskLevel,
    getRiskAcceptanceAndRiskLevel,
    getRiskAcceptanceAndRiskLevelGraph
} from 'plugin-codaf-risk-ext-bowtie/services/reportEvents'
import { IAlarp, IAlarpThreshold } from 'plugin-codaf-risk-ext-bowtie/types'
import { OrderFields } from 'plugin-codaf-risk-ext-bowtie/types/enums'
import { IRiskAcceptanceAndRiskLevelGraphic, IRiskAcceptanceReport } from 'plugin-codaf-risk-ext-bowtie/types/reports'

import { FunctionGetAlarpStatus, getAlarpStatusByName, getTopEventStatusName } from '../../../../../utils'
import { NoData, NoInfo } from '../../styles'
import { ReportPopover } from '../ReportFilter/ReportPopover'
import { RiskAcceptanceGraph } from '../ReportGraph/RiskAcceptanceGraph'

interface IProps {
    setItemsLength: (k: number) => void
    start: number
    numberOfItems: number
    time: string | null
    startDay: string | null
    endDay: string | null
    startHour: string | null
    endHour: string | null
    alarpList: IAlarp[]
    page: number
    setPage: (k: number) => void
    setExportLoading: (k: boolean) => void
}

interface IOrder {
    field: string
    order: boolean
}

interface ITopEventDataToGraph {
    topEventId: number
    topEventName: string
    bowtieMethod: string
}

export const RiskAcceptance = React.forwardRef<any, IProps>(function RiskAcceptance(
    { setItemsLength, numberOfItems, startDay, startHour, endDay, endHour, alarpList, page, setPage, setExportLoading },
    ref
) {
    const [events, setEvents] = useState<IRiskAcceptanceReport>()
    const [isLoading, setIsLoading] = useState(false)
    const [loadingGraph, setLoadingGraph] = useState(true)

    const [searchResource, setSearchResource] = useState<string>('')
    const [listResource, setListResource] = useState(new Set<string>())
    const [filterResource, setFilterResource] = useState(new Set<string>())

    const [searchBowtieCode, setSearchBowtieCode] = useState<string>('')
    const [listBowtieCode, setListBowtieCode] = useState(new Set<string>())
    const [filterBowtieCode, setFilterBowtieCode] = useState(new Set<string>())

    const [searchBowtieName, setSearchBowtieName] = useState<string>('')
    const [listBowtieName, setListBowtieName] = useState(new Set<string>())
    const [filterBowtieName, setFilterBowtieName] = useState(new Set<string>())

    const [searchRiskLevelStatus, setSearchRiskLevelStatus] = useState<string>('')
    const [listRiskLevelStatus, setListRiskLevelStatus] = useState(new Set<string>())
    const [filterRiskLevelStatus, setFilterRiskLevelStatus] = useState(new Set<string>())

    const [searchDate, setSearchDate] = useState<string>('')
    const [listDate, setListDate] = useState(new Set<string>())
    const [filterDate, setFilterDate] = useState(new Set<string>())

    const [order, setOrder] = useState<IOrder>({ field: OrderFields.DATE, order: true })
    const [graphicData, setGraphicData] = useState<IRiskAcceptanceAndRiskLevelGraphic>({ reportEvent: [], total: 0 })
    const [graphicName, setGraphicName] = useState<ITopEventDataToGraph>({
        topEventId: 0,
        topEventName: '',
        bowtieMethod: ''
    })

    const [update, setUpdate] = useState<number>(0)

    const [selected, setSelected] = useState<number>()

    const dateConverter = (data): string => {
        const newDate = new Date(data)
        const formatedDate = moment(newDate).format('YYYY/MM/DD, hh:mm:ss a')

        return `${formatedDate}`
    }

    const functionGet = (bowtieMethod: string): FunctionGetAlarpStatus => {
        if (bowtieMethod === 'SEMI_QUALITATIVE') bowtieMethod = 'QUALITATIVE'

        const alarp = alarpList.find(alarp => alarp.methodTypeName === bowtieMethod).alarpThresholds

        return getAlarpStatusByName(alarp)
    }

    const renderTableRow = (): JSX.Element[] => {
        if (events?.reportEvent) {
            const renderObject = events?.reportEvent.map((item, index) => {
                return (
                    <tr
                        key={index}
                        className={`${selected === index ? 'trWithGraph trSelected' : 'trWithGraph'} risk-acceptance ${
                            index === 0 ? 'first-margin' : 0
                        }`}
                    >
                        <td valign="middle" className="resource common-width">
                            <button
                                className="toGraph"
                                onClick={() => {
                                    setGraphicName({
                                        topEventId: item.topEventId,
                                        topEventName: item.bowtieName,
                                        bowtieMethod: item.bowtieMethodType
                                    })
                                    setSelected(index)
                                }}
                            >
                                {item.resource}
                            </button>
                        </td>
                        <td valign="middle" className="bowtie-code common-width">
                            <button
                                className="toGraph"
                                onClick={() => {
                                    setGraphicName({
                                        topEventId: item.topEventId,
                                        topEventName: item.bowtieName,
                                        bowtieMethod: item.bowtieMethodType
                                    })
                                    setSelected(index)
                                }}
                            >
                                {item.bowtieCode}
                            </button>
                        </td>
                        <td valign="middle" className="bowtie-name common-width">
                            <button
                                className="toGraph"
                                onClick={() => {
                                    setGraphicName({
                                        topEventId: item.topEventId,
                                        topEventName: item.bowtieName,
                                        bowtieMethod: item.bowtieMethodType
                                    })
                                    setSelected(index)
                                }}
                            >
                                {item.bowtieName}
                            </button>
                        </td>
                        <td valign="middle" className={`${item.riskLevelStatus} risk-level common-width`}>
                            <button
                                className="toGraph"
                                onClick={() => {
                                    setGraphicName({
                                        topEventId: item.topEventId,
                                        topEventName: item.bowtieName,
                                        bowtieMethod: item.bowtieMethodType
                                    })
                                    setSelected(index)
                                }}
                            >
                                {item.riskLevelStatus}
                            </button>
                        </td>
                        <td valign="middle" className="date common-width">
                            <button
                                className="toGraph"
                                onClick={() => {
                                    setGraphicName({
                                        topEventId: item.topEventId,
                                        topEventName: item.bowtieName,
                                        bowtieMethod: item.bowtieMethodType
                                    })
                                    setSelected(index)
                                }}
                            >
                                {dateConverter(item.date)}
                            </button>
                        </td>
                    </tr>
                )
            })

            return renderObject
        }
    }

    // 2022-04-05 00:00 to 2022-04-05 23:59
    const dateFormatToRequisition = (dateToConvert): string => {
        const initialDateToRequisition = new Date(dateToConvert)
        const formatedInitialDate = moment(initialDateToRequisition).format('YYYY-MM-DD')

        return formatedInitialDate
    }

    const formatSetToArray = (setToFormat: Set<string>): string[] => {
        const arr = []
        setToFormat.forEach(item => {
            arr.push(item)
        })

        return arr
    }

    const convertDateToTs = (dateToTs: Set<string>): string[] => {
        const arr = []
        dateToTs.forEach(item => {
            const dateFormating = new Date(item).getTime()
            arr.push(dateFormating)
        })

        return arr
    }

    const getEvents = async (): Promise<void> => {
        try {
            setIsLoading(true)
            const topEventEvents = await getRiskAcceptanceAndRiskLevel({
                startDay: dateFormatToRequisition(startDay),
                startHour: startHour,
                endDay: dateFormatToRequisition(endDay),
                endHour: endHour,
                page: page,
                perPage: numberOfItems,
                sortBy: order.field,
                sortOrder: order.order ? 'ASC' : 'DESC',
                filterByResource: formatSetToArray(filterResource),
                filterByBowtieCode: formatSetToArray(filterBowtieCode),
                filterByBowtieName: formatSetToArray(filterBowtieName),
                filterByDate: convertDateToTs(filterDate),
                filterByRiskLevelStatus: formatSetToArray(filterRiskLevelStatus)
            })
            setEvents(topEventEvents)
            setItemsLength(topEventEvents.total)
        } catch (err) {
            globalNotification.error(err.message ?? i18n('An error occurred on list events.'))
        } finally {
            setIsLoading(false)
        }
    }

    useImperativeHandle(ref, () => ({
        async exportRiskAcceptanceAndRiskLevel() {
            try {
                setExportLoading(true)
                await exportRiskAcceptanceAndRiskLevel({
                    startDay: dateFormatToRequisition(startDay),
                    startHour: startHour,
                    endDay: dateFormatToRequisition(endDay),
                    endHour: endHour,
                    sortBy: order.field,
                    sortOrder: order.order ? 'ASC' : 'DESC',
                    filterByResource: formatSetToArray(filterResource),
                    filterByBowtieCode: formatSetToArray(filterBowtieCode),
                    filterByBowtieName: formatSetToArray(filterBowtieName),
                    filterByDate: convertDateToTs(filterDate),
                    filterByRiskLevelStatus: formatSetToArray(filterRiskLevelStatus)
                })
                globalNotification.success(i18n('Report exported successfully.'))
            } catch (error) {
                globalNotification.error(i18n('Error on exporting report.'))
            } finally {
                setExportLoading(false)
            }
        }
    }))

    useEffect(() => {
        getEvents()
    }, [
        startDay,
        startHour,
        endDay,
        endHour,
        page,
        order,
        filterResource,
        filterBowtieCode,
        filterBowtieName,
        filterRiskLevelStatus,
        filterDate
    ])

    useEffect(() => {
        setPage(1)
    }, [order, filterResource, filterBowtieCode, filterBowtieName, filterRiskLevelStatus])

    const handleGraphData = async (): Promise<void> => {
        try {
            setLoadingGraph(true)
            if (graphicName.topEventId !== 0) {
                const riskAcceptanceGraphic = await getRiskAcceptanceAndRiskLevelGraph({
                    startDay: dateFormatToRequisition(startDay),
                    startHour: startHour,
                    endDay: dateFormatToRequisition(endDay),
                    endHour: endHour,
                    filterByUniqueId: graphicName.topEventId.toString()
                })
                riskAcceptanceGraphic.reportEvent.map(el => {
                    const newObject = el
                    newObject.status = getTopEventStatusName(el.value, i18n, functionGet(graphicName.bowtieMethod))

                    return newObject
                })
                riskAcceptanceGraphic.reportEvent[
                    riskAcceptanceGraphic.reportEvent.length - 1
                ].finalDate = new Date().getTime()
                setGraphicData(riskAcceptanceGraphic)
            }
        } catch (err) {
            globalNotification.error(err.message ?? i18n('An error occurred on list events.'))
        } finally {
            setLoadingGraph(false)
        }
    }

    const onClearAllFilters = (): void => {
        setUpdate(update + 1)
        globalNotification.success(i18n('Filters removed successfully.'))
    }

    useEffect(() => {
        handleGraphData()
    }, [graphicName])

    return (
        <>
            <button className="clearAllFilters" onClick={() => onClearAllFilters()}>
                {i18n('Clear all filter view')}
                <i className="far fa-filter"></i>
            </button>
            <div className="tableContainerWithGraphic customScroll">
                <table>
                    <thead className="tableHeader">
                        <tr className="risk-acceptance-header">
                            <th className="common-width">
                                <ReportPopover
                                    search={searchResource}
                                    setSearch={setSearchResource}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.RESOURCE}
                                    list={listResource}
                                    setList={setListResource}
                                    filter={filterResource}
                                    setFilter={setFilterResource}
                                    onClearAll={update}
                                    buttonTitle={'resource'}
                                />
                            </th>
                            <th className="common-width">
                                <ReportPopover
                                    search={searchBowtieCode}
                                    setSearch={setSearchBowtieCode}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.BOWTIECODE}
                                    list={listBowtieCode}
                                    setList={setListBowtieCode}
                                    filter={filterBowtieCode}
                                    setFilter={setFilterBowtieCode}
                                    onClearAll={update}
                                    buttonTitle="bowtie code"
                                />
                            </th>
                            <th className="common-width">
                                <ReportPopover
                                    search={searchBowtieName}
                                    setSearch={setSearchBowtieName}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.BOWTIE_NAME}
                                    list={listBowtieName}
                                    setList={setListBowtieName}
                                    filter={filterBowtieName}
                                    setFilter={setFilterBowtieName}
                                    onClearAll={update}
                                    buttonTitle="bowtie name"
                                />
                            </th>
                            <th className="common-width">
                                <ReportPopover
                                    search={searchRiskLevelStatus}
                                    setSearch={setSearchRiskLevelStatus}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.STATUS}
                                    list={listRiskLevelStatus}
                                    setList={setListRiskLevelStatus}
                                    filter={filterRiskLevelStatus}
                                    setFilter={setFilterRiskLevelStatus}
                                    onClearAll={update}
                                    buttonTitle="risk level"
                                />
                            </th>
                            <th className="common-width">
                                <ReportPopover
                                    search={searchDate}
                                    setSearch={setSearchDate}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.DATE}
                                    list={listDate}
                                    setList={setListDate}
                                    filter={filterDate}
                                    setFilter={setFilterDate}
                                    onClearAll={update}
                                    buttonTitle="date/time"
                                    last
                                />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? (
                            <NoInfo>
                                <i className="fa fa-spinner fa-spin" />
                            </NoInfo>
                        ) : events?.total === 0 ? (
                            <NoData>{i18n('There is no data for the specified period.')}</NoData>
                        ) : (
                            renderTableRow()
                        )}
                    </tbody>
                </table>
            </div>
            <RiskAcceptanceGraph loading={loadingGraph} data={graphicData} description={graphicName} />
        </>
    )
})
